import { Box, MenuItem, Select } from '@mui/material'
import { availableLang } from '../models/Lang'
import { allowedLangOptions } from '../config/header'
import LangSelectorButton from '../lang/LangSelectorButton'
import { useTranslation } from 'react-i18next'
import { primary } from '../styles/colors'

type Props = {
    lang: availableLang;
    setLang: (lang: availableLang) => void;
}

const FlagSelect = (props: Props) => {
    const { t } = useTranslation();

    return (
        <Select
            value={props.lang}
            onChange={(e) => props.setLang(e.target.value as availableLang)}
            variant='outlined'
            title={t("menu.category_and_items_language")}
            sx={{
                '.MuiOutlinedInput-notchedOutline': { border: 'none' },
                '.MuiSelect-select': { padding: 0 },
                backgroundColor: 'transparent',
                '& .MuiSelect-icon': {
                    color: primary,
                    paddingBottom: '2px',
                },
            }}
        >
            {allowedLangOptions.map(lang => (
                <MenuItem key={`lang-option-${lang.iso}`} value={lang.value}>
                    <Box pb={0.4}>
                        <LangSelectorButton
                            onClick={() => props.setLang(lang.value as availableLang)}
                            imgUrl={process.env.REACT_APP_PUBLIC_URL + '/assets/flags/' + lang.iso.toLowerCase() + '.png'}
                            title={lang.label}
                            size="small"
                        />
                    </Box>
                </MenuItem>
            ))}
        </Select>
    )
}

export default FlagSelect